module.exports = __webpack_public_path__ + "static/2-e1c6b6d8dee6d081f39cfb4a1b6673e1.jpg";